import { render, staticRenderFns } from "./BookingButtons.vue?vue&type=template&id=2641a94c&lang=pug&"
import script from "./BookingButtons.vue?vue&type=script&lang=ts&"
export * from "./BookingButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports